import { ILegacy_FloorPlanDto_Props } from './Legacy_FloorPlanDto.if';
import type { IModelSource } from '../interface/db';
import type IMediumDto from './MediumDto.if';
import type ISiteDto from './SiteDto.if';
import type IStyleDto from './StyleDto.if';
import type ISiteObjectOnFloorPlanDto from './SiteObjectOnFloorPlanDto.if';
import type ISiteObjectDto from './SiteObjectDto.if';

export interface ILegacy_FloorPlanDto_Linkables {
    image: (db: IModelSource) => Promise<IMediumDto>;
    site: (db: IModelSource) => Promise<ISiteDto>;
    style: (db: IModelSource) => Promise<IStyleDto>;
    allSiteObjectsOnFloorplan: (db: IModelSource) => Promise<Array<ISiteObjectOnFloorPlanDto>>;
    siteObjectOnFloorplan: (
        siteObject: ISiteObjectDto,
        db: IModelSource,
    ) => Promise<ISiteObjectOnFloorPlanDto>;
}

function _image(this: Partial<ILegacy_FloorPlanDto_Props>, db: IModelSource): Promise<IMediumDto> {
    return this.imageMediumId
        ? db.get('IMediumDto', this.imageMediumId)
        : Promise.reject('Missing field legacy_floorPlan.imageMediumId');
}

function _site(this: Partial<ILegacy_FloorPlanDto_Props>, db: IModelSource): Promise<ISiteDto> {
    return this.siteId
        ? db.get('ISiteDto', this.siteId)
        : Promise.reject('Missing field legacy_floorPlan.siteId');
}

function _style(this: Partial<ILegacy_FloorPlanDto_Props>, db: IModelSource): Promise<IStyleDto> {
    return this.styleId
        ? db.get('IStyleDto', this.styleId)
        : Promise.reject('Missing field legacy_floorPlan.styleId');
}

function _allSiteObjectsOnFloorplan(
    this: ILegacy_FloorPlanDto_Props,
    db: IModelSource,
): Promise<ISiteObjectOnFloorPlanDto[]> {
    if (!this.id) {
        return Promise.reject('Missing field legacy_floorPLan.id');
    }

    const _that = this;
    return new Promise(function (resolve, reject) {
        db.all('ISiteObjectOnFloorPlanDto')
            .then(soFPs => {
                const match = soFPs.filter(x => x.floorPlanId === _that.id);
                if (match.length > 0) {
                    resolve(match);
                } else {
                    reject('No SiteObjectOnFloorplans found for floorplanId:' + _that.id);
                }
            })
            .catch(error => reject(error));
    });
}

function _siteObjectOnFloorplan(
    this: ILegacy_FloorPlanDto_Props,
    siteObject: ISiteObjectDto,
    db: IModelSource,
): Promise<ISiteObjectOnFloorPlanDto> {
    if (!this.id) {
        return Promise.reject('Missing field legacy_floorPLan.id');
    }

    const _that = this;
    return new Promise(function (resolve, reject) {
        _allSiteObjectsOnFloorplan
            .call(_that, db)
            .then(soFPs => {
                const match = soFPs.filter(x => x.siteObjectId === siteObject.id);
                if (match.length > 0) {
                    resolve(match[0]);
                } else {
                    reject(
                        `No matching soFPs found for floorplanId ${_that.id}/siteObjectId: ${siteObject.id}`,
                    );
                }
            })
            .catch(error => reject(error));
    });
}

/** 
 * @description all custom properties for
   LanguageDto & methods to link against other entities
*/
function linkables(model: Partial<ILegacy_FloorPlanDto_Props>): ILegacy_FloorPlanDto_Linkables {
    return {
        image: _image,
        site: _site,
        style: _style,
        allSiteObjectsOnFloorplan: _allSiteObjectsOnFloorplan,
        siteObjectOnFloorplan: _siteObjectOnFloorplan,
    };
}

export default linkables;
